import { useMemo } from 'react';
import { isPlatformChromeTenant } from '../../app/platformChromeTenant.js';
import { useTenantCode } from '../../shared/tenant/TenantProvider.js';
import { useCustomerSurfaceEntitlement } from '../entitlements/customerEntitlementGuards.js';
import { useCustomerFeatureFlags } from '../flags/useCustomerFeatureFlags.js';
import {
  resolveGiftSurfaceVisibility,
  type GiftSurfaceVisibility,
} from './giftSurfaceVisibility.js';

export function useGiftSurfaceVisibility(): GiftSurfaceVisibility {
  const tenantCode = useTenantCode();
  const { isBlockEntitled } = useCustomerSurfaceEntitlement();
  const { flags, flagsReady } = useCustomerFeatureFlags();

  return useMemo(
    () =>
      resolveGiftSurfaceVisibility({
        isBlockEntitled,
        flags,
        flagsReady,
        platformChrome: isPlatformChromeTenant(tenantCode),
      }),
    [flags, flagsReady, isBlockEntitled, tenantCode],
  );
}
